import type { ChipOwnProps } from '@mui/material';
import type { GridOptions } from 'ag-grid-enterprise';

export const CASE_VERDICT_VARIANTS: Record<string, ChipOwnProps['color']> = {
  'True Positive': `error`,
  'False Positive': 'secondary',
  'Benign Activity': 'secondary',
  Closed: 'info',
  Acknowledged: 'info',
  Remediated: 'info'
} as const;

export const CASE_GRID_OPTIONS: GridOptions = {
  animateRows: false,
  defaultColDef: {
    resizable: true,
    sortable: true,
    suppressHeaderMenuButton: true
  },
  pagination: true,
  paginationPageSize: 20,
  paginationPageSizeSelector: [10, 20, 50, 100],
  rowHeight: 55,
  suppressCellFocus: true,
  suppressMultiSort: true,
  suppressContextMenu: true
};
